import styled, {css} from 'styled-components';
import theme from './theme';

export const CommonMainWrap = styled.div`
    width: 100%;
    min-height: calc(100vh - 3rem - 50px);
    max-height: calc(100vh - 3rem - 50px);
    height: 100%;
    overflow:auto;
`;

export const CommonSubBox = styled.div`
    height: 3.5rem;
    display: flex;
    align-items: start;
    gap: 8px;
    padding: 8px 0px;
`;

export const CommonGridBox = styled.div`
    height: calc(100vh - 3rem - 55px - 3.5rem - 1rem);
`;

const backDim = css`
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 5000;
    display: flex;
    justify-content: center;
    align-items: center;
`;


export const CommonModalWrap = styled.div`
    ${backDim}
`;


export const ListDetailTemplate = styled.div`
    width: 100%; 
    height: inherit;
    min-height: inherit;
    max-height: inherit;
    flex-grow: 1; 
    border: 1px solid ${theme.color.black[40]};
    border-radius: 12px;
    display: grid;
    grid-template-columns: minmax(10rem,15rem) auto;
    align-items: stretch;
    .list {
        display:flex;
        flex-direction: column;
        width: 100%;
        height: calc(100% - 2rem);
        min-height: calc(100% - 2rem);
        margin: 1rem 0;
        padding: 0 1rem;
        border-right: 1px solid ${theme.color.black[40]};
        overflow: hidden;
    }
    .detail {
        width: 100%;
        height: calc(100% - 2rem);
        min-height: calc(100% - 2rem);
        max-height: calc(100% - 2rem);
        margin: 1rem 0;
        padding: 0 1rem;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        overflow: hidden;
        justify-content: flex-start;
    }
`;


export const OneList = styled.div`
    display: flex;
    flex-grow:1;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    overflow:hidden;

    .titleLine {
        list-style-type: none;
        padding:0;
        // padding: 0 0.4rem;
        margin:0;
        border-bottom:2px solid ${theme.color.black[40]};
        li {
            display: grid;
            // grid-template-columns: 2rem 14rem 2rem 4rem 4rem 3rem 3rem 20rem 22rem 10rem;
            grid-template-columns: 2rem 14rem;
            gap: 0.8rem;
            font-size: 1rem;
            font-weight: bold;
            line-height: 2rem;
            height: 2rem;
        }
    }
    .descArea {
        flex-grow: 1;
        list-style-type: none;
        width: 100%;
        max-height: 100%;
        padding: 0;
        margin: 0;
        cursor: pointer;
        overflow:auto;
        .descLiItem  {
            width: 100%;
            gap: 0.8rem;
            font-size: 1rem;
            line-height: 2rem;
            height: 2rem;
            border-bottom: 1px solid ${theme.color.black[20]};
            display: grid;
            grid-template-columns: 2rem 14rem;
            gap: 1rem;
            span:nth-child(1) {
                text-align: right;
            }
        }
        .descLiItem:last-child{
            border: 0;
        }
        .selected {
            background: ${theme.color.primary.pupple2};
        }
    }
`;